import Checkbox from 'components/checkbox'
import RecruiterCandidateDestination from 'entities/user_notice/recruiter_destination_candidate'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './list_item.module.scss'

const RecruiterListItem = ({ isChecked, recruiter, onChange }) => {
  const formId = `user-notice-content-destination-recruiter-${recruiter.id}`

  return (
    <div className={styles.row} key={recruiter.id}>
      <div className={styles.checkbox}>
        <Checkbox
          checkboxId={formId}
          checkboxName="recruiter[id][]"
          defaultValue={recruiter.id}
          isChecked={isChecked}
          onChange={() => onChange(recruiter.id)}
        />
      </div>
      <label className={styles.names} htmlFor={formId}>
        <div className={styles.recruiterNames}>
          <span className={styles.recruiterName}>{recruiter.name}</span>
          {isEmpty(recruiter.tags)
            ? null
            : recruiter.tags.map(tag => (
                <span className={styles.tag} key={tag.id}>
                  {tag.name}
                </span>
              ))}
        </div>
        <div className={styles.recruiterAttributes}>
          {recruiter.number ? <span>{recruiter.number}</span> : null}
          <span>{recruiter.group.name}</span>
        </div>
      </label>
    </div>
  )
}

RecruiterListItem.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  recruiter: PropTypes.instanceOf(RecruiterCandidateDestination).isRequired,
  onChange: PropTypes.func.isRequired
}

export default RecruiterListItem
